export default __webpack_public_path__ + "static/media/Ballroll_00368.c2ada852.png";